@if (screenInfo$ | async; as screen) {
  <div style="display: flex; flex-direction: column; height: 100%">
    @if (isLoading) {
      <div
        style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
        <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
          <sh-spinner id="upcoming-services-details-spinner-1" site="s"></sh-spinner>
        </div>
      </div>
    }
    @if (!isLoading && upcomingservicedetails) {
      <div style="flex: 1 1 auto; height: 100%;">
        <p-table [size]="'small'" #table [value]="upcomingservicedetails" [scrollable]="true" scrollHeight="flex"
          rowGroupMode="subheader" [customSort]="true" (sortFunction)="customSort($event)" [sortField]="'target'"
          [sortOrder]="1">
          <!-- Tools -->
          <ng-template #caption style="border: none;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <sh-text id="upcoming-services-details-text-2" size="title-1" style="flex: 1 1 40%;">{{ 'upcomingServicesDetails.title' | transloco }}</sh-text>
              <div class="table-tools" style="flex: 1 1 60%; gap: 8px; align-items: center;">
                <!-- <p-columnFilter style="flex: 0 1 210px;" type="text" [showMenu]="false" field="serial_number"
                matchMode="contains">
                <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                  <sh-search id="upcoming-services-details-search-search-for-serial" no-border label="Search for Serial" condensed [(ngModel)]="searchTerm"
                  (ngModelChange)="filter($event)"></sh-search>
                </ng-template>
              </p-columnFilter> -->
              <span id="download-tooltip-target-upcoming-services" style="display: inline-flex; margin-left: -8px;">
                            <sh-icon id="download-upcoming-services" button [disabled]="isDownloading || (upcomingservicedetails.length === 0)" [icon]="isDownloading ? 'download-in-progress' : 'download'" size="s" (click)="download()"></sh-icon>
                        </span>
              <sh-icon id="upcoming-services-details-icon-4" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
              @if (workareaSize !== 'fullscreen') {
                <sh-icon id="upcoming-services-details-icon-5" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              }
              <sh-icon id="upcoming-services-details-icon-expand" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"
              [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              <sh-icon id="upcoming-services-details-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
              [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
            </div>
          </div>
        </ng-template>
        <!-- Header -->
        <ng-template #header>
          <tr>
            <th pSortableColumn="serial" style="min-width:200px;" pFrozenColumn>
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'upcomingServicesDetails.table.serialNumber' | transloco }}
                <p-sortIcon field="serial" />
              </div>
            </th>
            <th pSortableColumn="type" style="min-width:150px;">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'upcomingServicesDetails.table.type' | transloco }}
                <p-sortIcon field="type" />
              </div>
            </th>
            <th pSortableColumn="id" style="min-width:150px;">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'upcomingServicesDetails.table.id' | transloco }}
                <p-sortIcon field="id" />
              </div>
            </th>
            <th pSortableColumn="description" style="min-width:150px;">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'upcomingServicesDetails.table.description' | transloco }}
                <p-sortIcon field="description" />
              </div>
            </th>
            <th pSortableColumn="opened" style="min-width:150px;">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'upcomingServicesDetails.table.opened' | transloco }}
                <p-sortIcon field="opened" />
              </div>
            </th>
            <th pSortableColumn="scheduled" style="min-width:150px;">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'upcomingServicesDetails.table.scheduled' | transloco }}
                <p-sortIcon field="scheduled" />
              </div>
            </th>
            <th style="text-align: right;" pFrozenColumn alignFrozen="right">
            </th>
            <!--<th style="text-align: center;">
            Actions
          </th> -->
        </tr>
      </ng-template>
      <ng-template *ngIf="isDevice" let-rowData let-rowIndex="rowIndex" pTemplate="body">
        <tr>
          <td style="min-width:210px;" pFrozenColumn>
            {{serial}}
          </td>
          <td style="min-width:150px;">
            {{rowData.service_type}}
          </td>
          <td style="min-width:150px;">
            {{rowData.upcoming_service_id}}
          </td>
          <td style="min-width:150px;">
            {{rowData.description}}
          </td>
          <td style="min-width:150px;">
            {{rowData.opened | date:'mediumDate'}}
          </td>
          <td style="min-width:150px;">
            @if (rowData.scheduled != '1970-01-01T00:00:00Z') {
              <span>{{rowData.scheduled |
              date:'mediumDate'}}</span>
            }
            @if (rowData.scheduled == '1970-01-01T00:00:00Z') {
              <span>-</span>
            }
          </td>
          <td style="min-width:50px;" pFrozenColumn alignFrozen="right">
            <div style="width:100%; display: flex; align-items: center; justify-content: flex-end;">
              @if (rowData.service_type==='PSM') {
                <sh-button id="upcoming-services-details-button-details" size="auto"  color="tertiary"
                  [attr.label]="'upcomingServicesDetails.button.details' | transloco"
                (click)="focusNotification(rowData.pattern_id, rowData.service_type)"></sh-button>
              }
              @if (rowData.service_type!=='PSM') {
                <sh-button id="upcoming-services-details-button-details" size="auto"  color="tertiary"
                  [attr.label]="'upcomingServicesDetails.button.details' | transloco"
                (click)="focusNotification(rowData.upcoming_service_id, rowData.service_type)"></sh-button>
              }
            </div>
          </td>
          <!--                     <td style="min-width:50px;">
          <sh-button id="upcoming-services-details-button-9" color="tertiary" [disabled]="rowData.service_type==='PSM'" [label]="rowData.service_type === 'PSM' ? 'Coming Soon...' : 'Details'" (click)="focusNotification(rowData.upcoming_service_id, rowData.service_type)"></sh-button>
        </td> -->
      </tr>
    </ng-template>
    <ng-template *ngIf="!isDevice" let-rowData let-rowIndex="rowIndex" pTemplate="body">
      <tr>
        <td style="min-width:210px;" pFrozenColumn>
          <sh-button id="upcoming-services-details-button-open-link"
            (click)="openWithParams({ material: rowData['material_number'], serial: rowData['serial_number'] })"
            compact icon="open-link" icon-position="left" [label]="rowData.serial_number" size="auto"
          color="secondary"></sh-button>
        </td>
        <td style="min-width:150px;">
          {{rowData.service_type}}
        </td>
        <td style="min-width:150px;">
          {{rowData.upcoming_service_id}}
        </td>
        <td style="min-width:150px;">
          {{rowData.description}}
        </td>
        <td style="min-width:150px;">
          {{rowData.opened | date:'mediumDate'}}
        </td>
        <td style="min-width:150px;">
          @if (rowData.scheduled != '1970-01-01T00:00:00Z') {
            <span>{{rowData.scheduled |
            date:'mediumDate'}}</span>
          }
          @if (rowData.scheduled == '1970-01-01T00:00:00Z') {
            <span>-</span>
          }
        </td>
        <td pFrozenColumn alignFrozen="right">
          <div style="width:100%; display: flex; align-items: center; justify-content: flex-end;">
            @if (rowData.service_type==='PSM') {
              <sh-button id="upcoming-services-details-button-details" size="auto"  color="tertiary"
                [attr.label]="'upcomingServicesDetails.button.details' | transloco"
              (click)="focusNotification(rowData.pattern_id, rowData.service_type)"></sh-button>
            }
            @if (rowData.service_type!=='PSM') {
              <sh-button id="upcoming-services-details-button-details" size="auto"  color="tertiary"
                [attr.label]="'upcomingServicesDetails.button.details' | transloco"
              (click)="focusNotification(rowData.upcoming_service_id, rowData.service_type)"></sh-button>
            }
          </div>
        </td>
        <!--                     <td>
        <sh-button id="upcoming-services-details-button-13" size="auto" [disabled]="rowData.service_type==='PSM'" color="tertiary" [label]="rowData.service_type === 'PSM' ? 'Coming Soon...' : 'Details'" (click)="focusNotification(rowData.upcoming_service_id, rowData.service_type)"></sh-button>
      </td> -->
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="24">
        @if (!isError) {
          <div
            style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
            <sh-icon id="upcoming-services-details-icon-warning" icon="warning" size="s"></sh-icon>
            <span>{{ 'upcomingServicesDetails.empty.noData' | transloco }}</span>
          </div>
        }
        @if (isError) {
          <div
            style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
            <sh-icon id="upcoming-services-details-icon-error" icon="error" size="s"></sh-icon>
            <span>{{ 'common.empty.error' | transloco }}</span>
          </div>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
</div>
}
</div>
}